// extracted by mini-css-extract-plugin
export default {"switch":"WagonsViewSwitch_switch__EmYjC","slider":"WagonsViewSwitch_slider__GroFq","map":"WagonsViewSwitch_map__jl6RF","report":"WagonsViewSwitch_report__rle4C"};